import { PortalActivityPage } from '@command-center/oneup-portal-ui';
import { leadloopApi } from '../lib/leadloop-api';

/**
 * Cascade Activity.
 *
 * The shared platform viewer, scoped to this install. The scope is enforced in
 * the Worker (`cascadeActivityScope`), not here — this page could not widen it
 * even if it tried, which is why it can safely offer the full filter set.
 *
 * There is no Organization or App selector: Cascade is a single-tenant install
 * serving one app, so both dimensions are already pinned and a control for
 * either could only ever return nothing.
 *
 * No Health tab either. That panel reports the One Up Airtable mirror queue,
 * which is not Cascade's background work; showing it here would report on
 * somebody else's jobs.
 */
export function ActivityView() {
  return (
    <PortalActivityPage
      tabs={['user', 'system', 'all', 'ai']}
      defaultTab="user"
      storagePrefix="act"
      activity={{ list: (params) => leadloopApi.activityLogs(params) }}
      ai={{
        list: (params) => leadloopApi.aiLogs(params),
        usage: (params) => leadloopApi.aiUsage(params),
      }}
      labels={{ ai: 'AI Usage' }}
      searchPlaceholder="Search leads, contacts, calls, forms, or emails…"
      emptyMessages={{
        user: 'No one has done anything in LeadLoop in this range.',
        system:
          'No calls, form entries, emails, Switch runs, or background processing in this range.',
        all: 'No activity yet — the timeline fills in as the portal and Alice do work.',
        ai: 'Alice and the AI Switches have not run in this range.',
      }}
    />
  );
}
